import { useSnackbar } from "notistack";
import {
  syncModule as syncModuleService,
  syncDisabledModule as syncDisabledModuleService,
} from "../../services/maintenance/maintenance.service";
import { validate } from "../../utils";
import { handlerErrorV2 } from "../../utils/errors";
import isEmpty from 'lodash/isEmpty';
import { toggleAlertInfo } from "../../store/actions/alert.actions";
import { useDispatch } from "react-redux";

const useMaintenance = () => {
  const { enqueueSnackbar } = useSnackbar()
  const dispatch = useDispatch();

  const validateForm = (module, form) => {
    const fieldRules = {}

    if (module === 'users') {
        fieldRules.userType = 'required'
    }

    const errors = validate(fieldRules, form)
    if (!isEmpty(errors)) {
      return { error: true, ...errors }
    }

    if (!['users', 'classes', 'subjects'].includes(module)) {
        return {
          error: true,
          message: 'Module invalid'
        }
    }

    return { error: false }
  }

  const syncModule = async (module, form = {}) => {
    const result = validateForm(module, form);
    if (result.error) {
      return result
    };
    dispatch(
      toggleAlertInfo(
        true,
        `Syncing ${module} list`,
        "Please wait as this may take a few minutes",
        "loading"
      )
    );
    try {
      const response = await syncModuleService(module, form);
      if (!response.data && response.error) {
        return { error: true, message: response.error.message || 'An error ocurred'}
      } else {
        enqueueSnackbar(`${module} synced successfully`, { variant: 'success' })
        return { error: false }
      }
    } catch (error) {
      const message = handlerErrorV2(error)
      return { error: true, message }
    } finally {
      dispatch(toggleAlertInfo(false));
    }
  }

  const syncDisabledModule = async (module, form = {}) => {
    dispatch(
      toggleAlertInfo(
        true,
        `Disabling ${module}`,
        "Please wait as this may take a few minutes",
        "loading"
      )
    );
    try {
      const response = await syncDisabledModuleService(module, form);
      if (!response.data && response.error) {
        return { error: true, message: response.error.message || 'An error ocurred'}
      } else {
        enqueueSnackbar(`${module} disabled successfully`, { variant: 'success' })
        return { error: false }
      }
    } catch (error) {
      const message = handlerErrorV2(error)
      return { error: true, message }
    } finally {
      dispatch(toggleAlertInfo(false));
    }
  }

  return {
    syncModule,
    syncDisabledModule
  }
};

export default useMaintenance;